<template>
  <Card class="library-detail-card dummy-detail-card">
    <div class="card-cover-img-thumb"></div>
    <div class="card-block">
      <div class="card-info-section">
        <div class="row"></div>
        <div class="row"></div>
        <div class="row"></div>
      </div>

      <div class="card-keywords-section">
        <div class="row"></div>
      </div>
    </div>
  </Card>
</template>

<script>
  export default {
    name: 'dummy-detail-card',
  };
</script>

<style lang="scss">
  .dummy-detail-card {
    height: 420px;

    .card-cover-img-thumb {
      background-color: #f7f7f7;
    }

    .card-info-section>.row {
      width: 180px;
      height: 12px;
      background-color: #f7f7f7;
      margin-bottom: 12px;
    }

    .card-keywords-section>.row {
      width: 180px;
      height: 12px;
      background-color: #f7f7f7;
      margin-top: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DummyDetailCard.vue